type ScrollDirection = 'up' | 'down';

const THRESHOLD = 10;
const HEADER_HEIGHT = 64;

export const initScrollDirection = (): {
  removeScrollDirectionListener: () => void;
} => {
  if (typeof window === 'undefined') {
    return {
      removeScrollDirectionListener: () => {},
    };
  }

  let scrollDirection: ScrollDirection = 'up';
  let isScrollTop = true;
  let blocking = false;
  let prevScrollY = window.scrollY;

  const updateScrollDirection = () => {
    const currentScrollY = window.scrollY;

    const newScrollTop = currentScrollY <= THRESHOLD;

    if (newScrollTop !== isScrollTop) {
      updateScrollTopClass(newScrollTop);
      isScrollTop = newScrollTop;
    }

    if (Math.abs(currentScrollY - prevScrollY) >= THRESHOLD) {
      const newScrollDirection = getScrollDirection(currentScrollY, prevScrollY);

      scrollDirection = updateScrollClasses(scrollDirection, newScrollDirection);

      prevScrollY = currentScrollY > 0 ? currentScrollY : 0;
    }

    blocking = false;
  };

  const onScroll = () => {
    if (!blocking) {
      blocking = true;
      window.requestAnimationFrame(updateScrollDirection);
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  updateScrollDirection();

  return {
    removeScrollDirectionListener: () => {
      window.removeEventListener('scroll', onScroll);
    },
  };
};

export const getScrollDirection = (currentScrollY: number, prevScrollY: number): ScrollDirection => {
  let scrollDirection: ScrollDirection = currentScrollY > prevScrollY ? 'down' : 'up';

  // Special case for header's height
  if (scrollDirection === 'down' && currentScrollY < HEADER_HEIGHT) {
    scrollDirection = 'up';
  }
  return scrollDirection;
};

export const updateScrollClasses = (scrollDirection: ScrollDirection, newScrollDirection: ScrollDirection) => {
  if (scrollDirection !== newScrollDirection) {
    // Update the body classes if necessary
    document.body.classList.remove(`scroll-${scrollDirection}`);
    document.body.classList.add(`scroll-${newScrollDirection}`);
  }
  return newScrollDirection;
};

const updateScrollTopClass = (isScrollTop: boolean) => {
  if (isScrollTop) {
    document.body.classList.add(`scroll-top`);
  } else {
    document.body.classList.remove(`scroll-top`);
  }
};
